import { render, staticRenderFns } from "./AntennaManagement.vue?vue&type=template&id=7604f8b3&"
import script from "./AntennaManagement.vue?vue&type=script&lang=js&"
export * from "./AntennaManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports